import Agenda from './container';

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/Agenda/index.js